const Widths = {
  contractNo: '11%',
  vendor: '20%',
  project: '34%',
  poNo: '11%',
  poAmount: '8%',
  amount: '8%',
  balance: '8%'
};

const TableClass = "table table-condensed table-hover table-responsive";

export { Widths, TableClass }


// WEBPACK FOOTER //
// ./src/components/constants.js